import type { ReactNode } from 'react';

import { useCookieConsent } from './useCookieConsent';

interface Props {
  children: ReactNode;
  cookieUrl: string;
}

const CookiesConfig = ({ children, cookieUrl }: Props) => {
  useCookieConsent(cookieUrl);

  return <>{children}</>;
};

export default CookiesConfig;
